window.uccbGetBreakpoints = () => {
	if( window.UC && ( 'function' === typeof window.UC.tailwindBreakpoints.get ) ){
		return window.UC.tailwindBreakpoints.get();
	}
	return {};
}

window.uccbGetBreakpointsPx = () => {
	if( window.UC && ( 'function' === typeof window.UC.tailwindBreakpoints.getPx ) ){
		return window.UC.tailwindBreakpoints.getPx();
	}
	return {};
}